import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../config/config";


export const GetAdmin = createAsyncThunk(
    "dummyData/GetAdminDetail",
    async () => {
      const token = sessionStorage.getItem("ots_token");
  
      let response = await axios.get(`${BASE_URL}/admin/stats`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
  
      return response.data;
    }
  );
  



const GetAdminDetail = createSlice({
    name: "getAdminDetail",
    initialState: {
      loading: false,
      GetAdminDetail: null,
      error: "",
    },
    extraReducers: (builder) => {
      builder
        .addCase(GetAdmin.pending, (state) => {
          state.loading = true;
        })
        .addCase(GetAdmin.fulfilled, (state, action) => {
          state.loading = false;
          // Handle different response structures from axios interceptor
          // API returns: { success: true, data: { property_detail: [...], landlord_detail: [...], ... } }
          const payload = action.payload;
          if (payload?.data) {
            // If response has nested data (from interceptor)
            state.GetAdminDetail = payload.data;
          } else {
            // Direct data
            state.GetAdminDetail = payload;
          }
        })
        .addCase(GetAdmin.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
        });
    },
  });
  
export default GetAdminDetail.reducer;